/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


import state from './moduleCompetencyProgressState.js'
import mutations from './moduleCompetencyProgressMutations.js'
import actions from './moduleCompetencyProgressActions.js'
import getters from './moduleCompetencyProgressGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
